import { render } from "./DDProfiles.vue?vue&type=template&id=0e376a88"
import script from "./DDProfiles.vue?vue&type=script&lang=js"
export * from "./DDProfiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__